"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultCalculateEmojiSrc = void 0;
const remotion_1 = require("remotion");
const defaultCalculateEmojiSrc = ({ emoji, scale, format, }) => {
    const extension = format === 'hevc' ? 'mp4' : 'webm';
    return (0, remotion_1.staticFile)(`${emoji}-${scale}x.${extension}`);
};
exports.defaultCalculateEmojiSrc = defaultCalculateEmojiSrc;
